var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"mb-0 base-section-title user-name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }